// ISO 3166-1 alpha-2 markets supported by Cove storefronts.
export const SUPPORTED_COUNTRIES = ['US', 'CA'] as const;

export type SupportedCountry = (typeof SUPPORTED_COUNTRIES)[number];

const DEFAULT_COUNTRY: SupportedCountry = 'US';

const isSupportedCountry = (value: string): value is SupportedCountry =>
  (SUPPORTED_COUNTRIES as readonly string[]).includes(value);

/**
 * Build-time market identity.
 * Gatsby: GATSBY_COUNTRY. CRA: REACT_APP_COUNTRY.
 * Missing → US. Set but invalid → throw (fail the build / boot).
 */
const resolveCountry = (): SupportedCountry => {
  const raw = process.env.GATSBY_COUNTRY || process.env.REACT_APP_COUNTRY;

  if (!raw) {
    return DEFAULT_COUNTRY;
  }

  const normalized = raw.trim().toUpperCase();
  if (!isSupportedCountry(normalized)) {
    throw new Error(
      `Invalid market country "${raw}". Expected one of: ${SUPPORTED_COUNTRIES.join(
        ', '
      )}. Set GATSBY_COUNTRY or REACT_APP_COUNTRY.`
    );
  }

  return normalized;
};

export const COUNTRY: SupportedCountry = resolveCountry();

/** DatoCMS locale for SEO/content given UI language + build market. */
export const getDatoLocale = (
  language: string,
  country: SupportedCountry = COUNTRY
): string => {
  if (language === 'es') {
    return 'es';
  }
  if (country === 'CA') {
    return 'en-CA';
  }
  return 'en';
};
